module.exports = __webpack_public_path__ + "static/img/game16.f2ec437.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game16.jpg
// module id = moXu
// module chunks = 1